import { Controller } from "@hotwired/stimulus"

export default class MonthlyUnlockController extends Controller {
  static targets = ["modalBox", "dialog"]
  static values = { horoscopeId: String }

  connect() {
    this.backdrop = document.querySelector(".backdrop")
    this.pendingUrl = null
  }

  disconnect() {
    this.closeModal()
  }

  open(event) {
    this.pendingUrl = event.params.topicUrl

    this.modalBoxTarget.classList.remove("hidden")
    if (this.backdrop) this.backdrop.classList.add("show")
    this.dialogTarget.show()
  }

  closeModal() {
    this.modalBoxTarget.classList.add("hidden")
    if (this.backdrop) this.backdrop.classList.remove("show")
    this.dialogTarget.close()
  }

  redeem() {
    const csrfToken = document.querySelector("meta[name='csrf-token']").content

    fetch("/horoscopes/monthly_redeems", {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        horoscope_keystone_id: this.horoscopeIdValue
      })
    })
    .then(resp => {
      window.location.href = this.pendingUrl || window.location.pathname
    })
  }
}
